import React from 'react';
import { MapPinIcon, PhoneIcon, ShieldIcon, DownloadIcon, LinkedinIcon } from 'lucide-react';
export function Header() {
  return <header className="relative bg-gray-900 overflow-hidden border-b border-gray-800" data-id="element-279">
      <div className="absolute inset-0 z-0" data-id="element-280">
        <div className="absolute inset-0 bg-gradient-to-r from-gray-900 to-gray-800 opacity-90" data-id="element-281"></div>
        <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1582139329536-e7284fece509?q=80&w=2070&auto=format&fit=crop')] bg-cover bg-center opacity-20" data-id="element-282"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-gray-900 via-transparent to-transparent" data-id="element-283"></div>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-284">
        <div className="py-16 md:py-24 flex flex-col md:flex-row items-center md:items-start gap-8 md:gap-16" data-id="element-285">
          <div className="w-48 h-48 md:w-64 md:h-64 rounded-full overflow-hidden border-4 border-orange-500 shadow-xl flex-shrink-0" data-id="element-286">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/pZQNSHKT2AiEh6AYiaJCK8/Emre_Aksoy_Aanvraag_pas_pasfoto.jpg" alt="Emre Tarik Aksoy" className="w-full h-full object-cover" data-id="element-287" />
          </div>
          <div className="text-center md:text-left" data-id="element-288">
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight" data-id="element-289">
              Emre Tarik Aksoy
            </h1>
            <p className="mt-3 text-xl md:text-2xl text-orange-500 font-semibold" data-id="element-290">
              Professioneel Beveiliger
            </p>
            <div className="mt-6 flex flex-col sm:flex-row items-center justify-center md:justify-start gap-4 sm:gap-6" data-id="element-291">
              <div className="flex items-center gap-2" data-id="element-292">
                <MapPinIcon className="w-5 h-5 text-gray-400" data-id="element-293" />
                <span data-id="element-294">Amsterdam, Nederland</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-295">
                <PhoneIcon className="w-5 h-5 text-orange-500" data-id="element-296" />
                <span data-id="element-297">+31(6) 44657147</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-298">
                <ShieldIcon className="w-5 h-5 text-green-500" data-id="element-299" />
                <span data-id="element-300">Beveiliger sinds 2022</span>
              </div>
            </div>
            <div className="mt-6 flex flex-wrap justify-center md:justify-start gap-3" data-id="element-301">
              <a href="https://www.linkedin.com/" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-md transition-colors" data-id="element-302">
                <LinkedinIcon className="w-5 h-5" data-id="element-303" />
                <span data-id="element-304">LinkedIn</span>
              </a>
              <a href="#" className="flex items-center gap-2 px-4 py-2 bg-gray-700 hover:bg-gray-600 text-white font-medium rounded-md transition-colors" data-id="element-305">
                <DownloadIcon className="w-5 h-5" data-id="element-306" />
                <span data-id="element-307">Download CV</span>
              </a>
            </div>
            <div className="mt-8 flex flex-col sm:flex-row gap-4" data-id="element-308">
              <a href="#contact" className="px-6 py-3 bg-orange-500 hover:bg-orange-600 text-white font-semibold rounded-md transition-colors shadow-lg text-center" data-id="element-309">
                Beveiligingsdienst inhuren
              </a>
              <a href="#contact" className="px-6 py-3 border border-gray-600 hover:border-orange-500 text-gray-200 font-semibold rounded-md transition-colors text-center" data-id="element-310">
                Offerte aanvragen
              </a>
            </div>
          </div>
        </div>
      </div>
    </header>;
}